export const CarerEndpoints = {
  profile: "/:id/profile",
  profileOpenCareWorker: "/:id/profileOpenCareWorker",
  profileInfo: "/:id/profile/info",
  profileBasicInfo: "/:id/profile/basicInfo",
  profileJobsAppliedFor: "/:id/profile/jobsAppliedFor",
  profilePersonalDetails: "/:id/profile/personalDetails",
  profileExpAndTra: "/:id/profile/expAndTra",
  profileDocuments: "/:id/profile/documents",
  profileQualifications: "/:id/profile/qualifications",
  profileUploadFiles: "/:id/profile/upload-files",
  profileRating: "/:id/profile/rating",
  profileSummary: "/:id/profile/summary",
  profileAvatar: "/:id/profile/avatar",
  profileSubmit: "/:id/profile/submit",
  profileApprove: "/:id/profile/approve",
  profileDisable: "/:id/profile/disable",
  profileSendBack: "/:id/profile/send-back",

  onboardStatus: "/:id/profile/onboard-status",
  applicationStatus: "/:id/profile/application-status",

  search: "/search",
  searchInfo: "/search/info",
  exportCarers: "/export/carers",
  searchLocation: "/search/info",

  bankDetails: "/:id/bank-details",
  disconnectedBankDetailId: "/:id/bank-details/:accountId",
  bankDetailsChange: "/:id/bank-details",
  bankDetailsExpress: "/:id/bank-details/express",

  document: "/:id/document",
  documentGet: "/:id/document/:docId",
  documentDelete: "/:id/document/:docId",

  availabilities: "/:id/availabilities",
  updateAvailability: "/:id/availabilities/:availabilityId",
  availabilityRestore: "/:id/availabilities/restore",

  review: "/:id/review",
  profileReviews: "/:id/profile/reviews",
  serviceUserReviews: "/service-user/:serviceUserId/reviews",

  rateOfPay: "/:id/rate-of-pay",
  allRoles: "/role",
  activeRoles: "/activerole",
  rejectRoles: "/rejectrole",
  expiredRoles: "/expiredrole",
  historyRoles: "/historyrole",
  role: "/:id/role",
  withdrawRole: "/:id/role/:roleId/withdraw",
  approveRole: "/:id/role/:roleId/approve",
  rejectRole: "/:id/role/:roleId/reject",

  // Carer-side JobPost endpoints — `:id` is the carer's user id, used to
  // verify the authenticated session and look up active pay-rate roles for
  // role-based filtering. Mismatch with JWT subject → 403.
  getJobPosts: "/:id/job-post",
  jobPostById: "/:id/job-post/:jobPostId",
  getJobPostShiftById: "/:id/job-post/shift/:shiftId",
  jobPostApply: "/:id/job-post/apply",
  jobPostCancel: "/:id/job-post/cancel",

  booking: "/:id/booking",
  bookingCount: "/:id/booking/count",
  bookingId: "/:id/booking/:bookingId",
  bookingAccept: "/:id/booking/:bookingId/accept",
  bookingReject: "/:id/booking/:bookingId/reject",
  bookingShiftClockIn: "/:id/booking/:bookingId/shift/:shiftId/clock-in",
  bookingShiftClockOut: "/:id/booking/:bookingId/shift/:shiftId/clock-out",
  bookingShiftCarerReviewTasks:
    "/:id/booking/:bookingId/shift/:shiftId/carer-review-tasks",

  shiftTaskReview: "/:id/job/shift/tasks",
  jobReviewServiceUser: "/:id/job/:jobId/review",

  documentChecklist: "/:id/document-checklist",
  payRate: "/payRate",
  globalPayRateLimit: "/payRate/global-limit",
  audit: "/audit",
  enrolmentForm: "/enrolment-form",
  enrolmentForms: "/enrolment-forms",
  enrolmentFormById: "/enrolment-forms/:id",
  enrolmentFormStatus: "/enrolment-forms/:id/status",
  enrolmentFormAuditHistory: "/enrolment-forms/:id/audit-history",
};
